import { useEffect, useRef, useState } from 'react';
import { pageProgressMap } from '@/utils/contants/caseSimulation';
import { getToPathByStage } from './utils';

const useReviewReport = (props) => {
    let timerRef = useRef(null);
    let { navigate, params, side = 'web' } = props;
    let { caseId } = params;
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { simulation } = props.store;

    let { setHeaderIcon, getApiProgress, pageProgress, getContent, getPath } = simulation;

    useEffect(() => {
        setHeaderIcon({
            role: false,
            back: false,
            reStart: side === 'web' ? false : true
        });
    }, []);
    //清除定时器
    const clearTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };
    const getProgress = async () => {
        let progress = await getApiProgress(caseId);
        if (progress === pageProgressMap['report_ready']) {
            await getContent();
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            clearTimer();
        }
    };
    const startTimer = () => {
        console.log('定时器开始');
        if (timerRef.current) {
            return;
        }
        timerRef.current = setInterval(() => {
            getProgress();
        }, 3000);
    };
    //第一次进入页面的时候获取进度更改页面loading状态
    const getProgressInFirst = async () => {
        setPageLoading(true);
        let progress = await getApiProgress(caseId);
        if (progress === pageProgressMap['report_generating']) {
            setLoading(true);
            setPageLoading(false);
            startTimer();
        } else if (progress === pageProgressMap['report_ready']) {
            await getContent();
            setPageLoading(false);
        } else {
            let path = getToPathByStage(pageProgress);
            let prePath = getPath();
            navigate(`${prePath}/${path}`, { replace: true });
        }
    };
    const reGenerateReport = () => {
        getProgressInFirst();
    };
    useEffect(() => {
        getProgressInFirst();
        return () => {
            clearTimer();
        };
    }, []);

    //重新开始弹窗
    const showRestartModal = () => {
        simulation.setGuideModalShow({
            role: false,
            back: false,
            restart: true
        });
    };
    return {
        timerRef,
        pageLoading,
        setPageLoading,
        loading,
        setLoading,
        showRestartModal,
        reGenerateReport
    };
};

export default useReviewReport;
